import PropTypes from 'prop-types';
import { breakpoints, Card, Inline, LinkButton, vars } from '@etg/wings';
import { ProductIcon } from '@eti/products';
import { useTranslation } from '@eti/providers';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';

const iconStyles = css`
  align-items: center;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

const textWrapperStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 7px;
`;

const titleStyles = css`
  color: ${etiColors.black};
  font-size: 0.75rem;
`;

const subtitleStyles = css`
  color: ${etiColors.grayScale[9]};
  font-size: 0.75rem;
`;

const priceWrapperStyles = css`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: auto;
  margin-top: 7px;
  text-align: right;

  @media ${mediaQueries.medium.up} {
    justify-content: center;
    margin-top: 0;
    min-height: 71px;
  }

  html[dir='rtl'] & {
    text-align: left;
  }
`;

const priceTextStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.75rem;
  text-align: right;

  html[dir='rtl'] & {
    text-align: left;
  }
`;

const priceStyles = css`
  color: ${etiColors.black};
  font-size: 1rem;
  font-weight: 700;
`;

const addProductStyles = css`
  display: block;
  font-size: 0.75rem;
`;

const cardStyles = css`
  border: 1px solid ${vars.colors.divider};
`;

const ReviewProductItem = ({ id, onAdd, priceRaw, priceText, subtitle, title }) => {
  const { t } = useTranslation();
  const handleOnClick = () => {
    onAdd(id, { value: { value: true, priceRaw } });
  };

  return (
    <Card className={cardStyles} data-testid={`travelerDetails-reviewModal-extraProducts-${id}`}>
      <Inline alignY="top" collapseBelow={breakpoints._768} spacing={8}>
        <Inline noWrap spacing={8}>
          <ProductIcon className={iconStyles} id={id} />
          <div className={textWrapperStyles}>
            <div className={titleStyles}>{title}</div>
            <div className={subtitleStyles}>{subtitle}</div>
          </div>
        </Inline>
        {Number.isInteger(priceRaw) && (
          <div className={priceWrapperStyles}>
            {priceText && <div className={priceTextStyles}>{t(priceText)}</div>}
            <div className={priceStyles}>{priceUtils.formatPrice(priceRaw)}</div>
            <LinkButton
              className={addProductStyles}
              data-testid={`reviewModal-addProduct-${id}`}
              onClick={handleOnClick}
            >
              {t('TravelerDetails.Review.Modal.ExtraProducts.NotSelected.Add.Label')}
            </LinkButton>
          </div>
        )}
      </Inline>
    </Card>
  );
};

ReviewProductItem.propTypes = {
  id: PropTypes.string,
  onAdd: PropTypes.func,
  priceRaw: PropTypes.number,
  priceText: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default ReviewProductItem;
